// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { FormatFunction } from '../types';

export abstract class Mask {
  protected mask: string;

  public maxLength: number;

  constructor(mask: string, maxLength?: number) {
    this.mask = mask;
    this.maxLength = maxLength || mask.length;
  }

  abstract format: FormatFunction;

  abstract unformat(formattedValue: string): string;
}
